<template>
  <v-tooltip
    location="top"
    :text="tooltip"
    :disabled="!tooltip"
  >
    <template #activator="{ props: tooltipProps }">
      <v-btn
        icon
        variant="text"
        :size="size"
        :density="density"
        class="icon-btn"
        v-bind="{ ...tooltipProps, ...$attrs }"
      >
        <slot />
      </v-btn>
    </template>
  </v-tooltip>
</template>

<script>
// V4 v-btn icon size matrix — icon btn width/height = --v-btn-height + density-delta
//   density delta: default=+12px, comfortable=+0px, compact=-8px
//
//   size="default"  (--v-btn-height=36) density="default"     → 48px  (V4 framework default — IconBtn default)
//   size="default"  (--v-btn-height=36) density="comfortable" → 36px  (V2 <v-btn icon> baseline parity)
//   size="default"  (--v-btn-height=36) density="compact"     → 28px
//   size="small"    (--v-btn-height=28) density="comfortable" → 28px
//   size="small"    (--v-btn-height=28) density="compact"     → 20px  (V2 bare <v-icon size=20> parity)
//   size="x-small"  (--v-btn-height=20) density="comfortable" → 20px  (same 20px, comfortable)
//   size="x-small"  (--v-btn-height=20) density="compact"     → 12px  (too small — do NOT use for 20px target)
//
// Defaults below match V4 framework defaults (48px). Override per call site where
// a smaller/different button is needed.
export default {
  name: 'IconBtn',
  inheritAttrs: false,
  props: {
    size: {
      type: [String, Number],
      default: 'default',
    },
    density: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'comfortable', 'compact'].includes(v),
    },
    // Optional hover tooltip. When empty the v-tooltip is disabled, so IconBtn
    // renders exactly as a bare v-btn — no behaviour change for existing usages.
    tooltip: {
      type: String,
      default: '',
    },
  },
}
</script>
